import { useEffect, useState } from "react";

const fixedInputClass =
	'rounded-md appearance-none relative block w-2/5 mx-auto px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm';

const Input = ({
	handleChange,
	labelText,
	labelFor,
	id,
	name,
	type,
	placeholder,
	customClass,
	value = '',
	isRequired = false,
	withSpaces = true,
	extraAttributes = {},
	withDiv = true,
	fullWidthInput = false,
}) => {
	const [localValue, setLocalValue] = useState(value);

	useEffect(() => {
		setLocalValue(value);
	}, [value]);

	const handleLocalChange = (e) => {
		setLocalValue(e.target.value);
		handleChange(e);
	}

	return (
		<>
			{withDiv ? (
				<div className={`${withSpaces ? 'my-5' : ''} w-full`}>
					<label htmlFor={labelFor} className="sr-only">
						{labelText}
					</label>
					<input
						onChange={handleLocalChange}
						value={localValue}
						id={id}
						name={name}
						type={type}
						required={isRequired}
						className={customClass ? customClass : fixedInputClass + (fullWidthInput ? ' w-full' : '')}
						placeholder={placeholder}
						{...extraAttributes}
					/>
				</div>
			) : (
				<input
					onChange={handleLocalChange}
					value={localValue}
					id={id}
					name={name}
					type={type}
					required={isRequired}
					className={customClass ? customClass : fixedInputClass}
					placeholder={placeholder}
					{...extraAttributes}
				/>
			)}
		</>
	);
};

export default Input;
